module.exports = __webpack_public_path__ + "static/media/Student-dashboard-myclasses-All-2.a37f908c.png";